import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable, Inject } from "@angular/core";
import {AuthenticationAbstractService} from "./services/abstract/authentication.abstract.service";

@Injectable()
export class AuthenticationGuard implements CanActivate {

  constructor(
      @Inject("Auth") private authV3: AuthenticationAbstractService,
      private router: Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot) {
    let umotion = route.queryParams['umove'];
    let ucloud = route.queryParams['ucloud'];
    let ucloud_username = route.queryParams['username'];
    let url = route.queryParams['url'];
    if(umotion != null) {
      localStorage.setItem("token_umotion", umotion);
      sessionStorage.setItem("token_ucloud", ucloud);
      localStorage.setItem("username_ucloud", ucloud_username);
      localStorage.setItem("url_ucloud", url);
    }
    if(!this.authV3.isAuthenticated){
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
